<template>
  <RiseupHeader>
    <img :src="require('@/assets/nav/hamburger.svg')" v-on:click.stop="openNavBar"/>
  </RiseupHeader>
</template>

<script>

import NavigationBus from '../../event-bus/navigation-bus';
import RiseupHeader from './RiseupHeader.vue';

export default {
  name: 'NavigationHeader',
  components: {
    RiseupHeader,
  },
  methods: {
    openNavBar() {
      NavigationBus.$emit('open');
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
